import { observer } from 'mobx-react-lite';
import Product from '../../store/Product';
import BeforeInstallWidget from './beforeInstall/BeforeInstallWidget';
import DownloadWidget from './download/DownloadWidget';
import FileMovementWidget from './fileMovements/FileMovementWidget';
import HiseWidget from './hiseLink/HiseLinkWidget';
import InstallDialogWidget from './installDialog/InstallDialogWidget';
import MergingWidget from './productMerging/ProductMergingWidget';
import PulseVersionWidget from './pulseVersion/PulseVersionWidget';

export default observer(function ExtendedPanel({
  product,
}: {
  product: Product;
}) {
  return (
    <>
      <PulseVersionWidget product={product} />
      <MergingWidget product={product} sx={{ mt: 3 }} />
      <FileMovementWidget product={product} sx={{ mt: 3 }} />
      <HiseWidget product={product} sx={{ mt: 3 }} />
      <BeforeInstallWidget product={product} sx={{ mt: 3 }} />
      <InstallDialogWidget product={product} sx={{ mt: 3 }} />
      <DownloadWidget product={product} sx={{ mt: 3 }} />
    </>
  );
});
